/**
 * Capitalize the first letter of the first word in a string.
 */
export function capitalize(str: string): string {
  if (str === "") return str;
  return str[0].toUpperCase() + str.substring(1);
}

/**
 * Capitalize the first letter of every word in a string.
 */
export function capitalizeAll(str: string): string {
  const words = str.split(" ");
  return words.map(capitalize).join(" ");
}

/**
 * Tweaks a string for display to end users.
 * Specifically does the following:
 * * Splits camel case strings.
 * * Replaces underscores and dots with spaces.
 * * Capitalizes the first word, but can be turned off.
 */
export function humanize(str: string, capitalized = true): string {
  let result = separate(words(str));

  if (capitalized) {
    result = capitalize(result);
  }

  return result;
}

/**
 * Converts a string into dash separated words.
 *
 * Example: giveMe_chocolate -> give-me-chocolate
 */
export function parameterize(str: string): string {
  return separate(words(str), "-");
}

/**
 * Replaces `-`, `_`, and `.` with spaces. Character to replace with can be
 * changed.
 */
export function separate(str: string, char = " "): string {
  return str.replace(/_|\.|-/g, char);
}

/**
 * Converts camelCase string into words separated by space. Words are in lowercase.
 */
export function words(str: string): string {
  return str.replace(/([a-z\d])([A-Z])/g, "$1 $2").toLowerCase();
}

export function toNum(str: string): number | undefined {
  return str ? +str : undefined;
}
